import React from "react";
import { Form } from "semantic-ui-react";

interface DefaultSelectPlaceholderProps { };

export const DefaultSelectPlaceholder: React.FC<DefaultSelectPlaceholderProps> = ({
    ...selectProps
}) => {

    return (
        <Form.Select
            {...selectProps}
            options={[]}
            loading
            disabled
        />
    )
};


